import { render } from "./Kobun.vue?vue&type=template&id=ab8d9c44&ts=true"
import script from "./Kobun.vue?vue&type=script&lang=ts"
export * from "./Kobun.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__